<template>
  <div class="title">
    Invite by shareable link
  </div>
  <div class="body">
    <div class="dg form-group has-input-icon">
      <label for="shareable-url">Share this link in the messenger of your choice</label>
      <input
        id="shareable-url"
        :value="sharableUrl"
        readonly="readonly"
        type="text"
        @click="copyLink"
      >
      <i
        class="fa fas fa-link input-icon"
        @click="copyLink"
      />
    </div>
  </div>
  <div class="footer">
    <button
      class="dg secondary"
      @click="close"
    >
      Cancel
    </button>
    <button
      class="dg primary"
      @click="copyLink"
    >
      Copy Link
    </button>
  </div>
</template>

<script>
  import { mapActions, mapState } from "vuex"
  import { RH_VUE_URL } from "@/common/constants"

  export default {
    props: {
      rallyId: {
        required: true,
        type: Number,
      },
    },
    computed: {
      ...mapState("rallies", ["allRalliesByRallyId"]),
      sharableUrl() {
        return RH_VUE_URL() + "createAccount?createacc=" + this.rallyId
      }
    },
    methods: {
      ...mapActions("user", ["setModalProps"]),
      close() {
        this.setModalProps({})
      },
      copyLink() {
        const input = document.getElementById('shareable-url')
        input.select()
        document.execCommand('copy')
        this.$store.dispatch('user/flashSuccess', 'Copied!')
        this.close()
      },
    },
  }
</script>
